import styled from 'styled-components'

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background: linear-gradient(to right, #1b2330 0%, rgb(13, 17, 24) 100%);
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 2000;
  display: flex;
  justify-content: center;
  overflow: auto;
  padding: 1rem;
`

export const Wrapper = styled.div`
  margin: auto 0;
  background: white;
  border-radius: 30px;
  width: 100%;
  max-width: 600px;

  .logoDirecao {
    height: 100%;
    margin-left: 10px;
  }

  @media only screen and (min-width: 1090px) {
    display: flex;
    background: white;
    min-width: 300px;
    max-width: 1100px;

    .logoDirecao {
      height: 50px;
    }
  }
`

export const TextCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 60%;
  background: linear-gradient(to right, #1b2330 0%, rgb(13, 17, 24) 100%);
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  box-sizing: border-box;

  h1 {
    display: flex;
    justify-content: center;
    color: white;
    font-size: 4rem;
    margin-left: 5rem;
  }

  h3 {
    color: white;
    margin-left: 5rem;
    width: 70%;
  }

  @media only screen and (max-width: 1090px) {
    display: none;
  }
`

export const WrapperForm = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 0 auto;

  .logoDirecao {
    height: 100px;
  }

  p {
    padding-left: 1rem;

    b {
      color: #22d3ee;
      cursor: pointer;
    }
  }

  form {
    width: 90%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border: none;

    input {
      color: rgb(74, 74, 74);
    }

    p {
      color: #000;
    }

    button {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      padding: 15px;
      width: 80%;
      border: none;
      background-color: #252f3e;
      border-radius: 20px;
      margin: 2rem auto;

      &:disabled {
        background-color: #7c818a;
        cursor: not-allowed;
      }
    }
  }

  @media only screen and (min-width: 600px) and (max-width: 1090px) {
    width: 550px;

    form {
      width: 90%;
      margin: 3.5rem auto;
    }

    button {
      margin-left: 5rem;
    }
  }

  @media only screen and (min-width: 1090px) {
    padding-left: 1rem;

    width: 350px;

    form {
      width: 90%;
    }

    button {
      margin-left: 2.6rem;
    }

    p {
      padding-left: 1.5rem;
    }

    .logoDirecao {
      height: 100px;
    }
  }
`

export const SocialLoginWrapper = styled.div`
  margin: 1.5rem auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 600px;

  button {
    margin: 0.5rem auto;
  }

  @media only screen and (max-width: 1100px) {
    padding: 1rem;
  }
`
